import "../css/LogoSpinner.css";
import logo from "../images/uc-logo.png";
import React from 'react';

const LINES = 24;
const LOGO_WIDTH = 220;
const LOGO_HEIGHT = 360;

export function LogoSpinner({ overlay = true, height = LOGO_HEIGHT, width = LOGO_WIDTH, className = "" }) {
    const baseLineHeight = Math.floor(height / LINES);
    const remainder = height - baseLineHeight * LINES;

    return (
        <div
            className={overlay ? `spinner-overlay ${className}` : `spinner-inline ${className}`}
            style={overlay ? {} : { minHeight: height, minWidth: width, display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}
        >
            <div
                className="logo-container"
                style={{ width, height }}
            >
                {Array.from({ length: LINES }).map((_, i) => {
                    const direction = i % 4;

                    let dirClass;
                    switch (direction) {
                        case 0:
                            dirClass = "from-left";
                            break;
                        case 1:
                            dirClass = "from-right";
                            break;
                        case 2:
                            dirClass = "from-top";
                            break;
                        default:
                            dirClass = "from-bottom";
                    }

                    // 👇 la última línea absorbe el resto
                    const lineHeight =
                        i === LINES - 1
                            ? baseLineHeight + remainder
                            : baseLineHeight;

                    return (
                        <div
                            key={i}
                            className={`line ${dirClass}`}
                            style={{
                                height: `${lineHeight}px`,
                                backgroundImage: `url(${logo})`,
                                backgroundSize: `${width}px ${height}px`,
                                backgroundPosition: `0px -${i * baseLineHeight}px`,
                                animationDelay: `${i * 0.06}s`
                            }}
                        />
                    );
                })}
            </div>
        </div>
    );
}
